
<div *ngIf="!commonService.expiryFlag">
<router-outlet>
  <app-chat-screen class="chat-screen"></app-chat-screen>
  <!-- <div id="containerDiv" style="width: auto; height: 370px;"></div> -->
</router-outlet>
</div>